import axios from 'axios';
import { get, post, uploadfile } from '@/utils/request';

const base = '/api/v1/web_customer_service';
const externalBase = '/api/v1/external_customer_service';

const externalHeaders = (accessToken) => ({ Authorization: `External ${accessToken}` });
const externalResult = (request) => request.then((resp) => {
  if (resp.data && resp.data.code === 1) return resp.data.result;
  return Promise.reject((resp.data && resp.data.message) || '在线咨询请求失败');
}).catch((error) => {
  if (typeof error === 'string') return Promise.reject(error);
  return Promise.reject((error.response && error.response.data && error.response.data.message) || error);
});

export const externalCustomerServiceExchange = (ticket) => externalResult(axios.post(`${externalBase}/exchange`, { ticket }));
export const externalCustomerServiceUnreadRead = (accessToken) =>
  externalResult(axios.post(`${externalBase}/unread/read`, {}, { headers: externalHeaders(accessToken) }));

export const webCustomerServiceConversation = (params = {}, externalToken = '') => externalToken
  ? externalResult(axios.get(`${externalBase}/conversation`, { params, headers: externalHeaders(externalToken) }))
  : get(`${base}/conversation`, params);
export const webCustomerServiceSend = (content, externalToken = '') => externalToken
  ? externalResult(axios.post(`${externalBase}/conversation/messages`, { content }, { headers: externalHeaders(externalToken) }))
  : post(`${base}/conversation/messages`, { content });
export const webCustomerServiceAIAction = (action, externalToken = '') => externalToken
  ? externalResult(axios.post(`${externalBase}/conversation/ai_action`, { action }, { headers: externalHeaders(externalToken) }))
  : post(`${base}/conversation/ai_action`, { action });
export const webCustomerServiceMediaURL = (id, externalToken = '') => externalToken
  ? externalResult(axios.get(`${externalBase}/messages/${id}/media`, { headers: externalHeaders(externalToken) }))
  : get(`${base}/messages/${id}/media`);

export const webCustomerServiceSendMedia = (kind, file, externalToken = '') => {
  const data = new FormData();
  data.append('file', file);
  if (externalToken) return externalResult(axios.post(`${externalBase}/conversation/media/${kind}`, data, { headers: externalHeaders(externalToken) }));
  return uploadfile(`${base}/conversation/media/${kind}`, data);
};
